import { SET_MONEY, ADD_MONEY, RESET_PAYMENT, SET_PAYMENT_OPTIONS } from './constants';

const initialState = {
  isLoaded: false,
};

const payment = (state: any = initialState, action: any) => {
  switch (action.type) {
    case ADD_MONEY:
      return {
        ...state,
        isLoaded: false,
      };
    case SET_MONEY:
      return {
        ...state,
        isLoaded: true,
        paymentInfo: { ...action.data },
      };
    case SET_PAYMENT_OPTIONS:
      return {
        ...state,
        paymentOptions: { ...action.data },
      };
    case RESET_PAYMENT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default payment;
